module.exports = require("./fr-FR");